import React, { useMemo } from 'react'
import classnames from 'classnames'
import { Link } from 'react-router-dom'

import config from 'config'
import { useBreakpoints, useCustomerSupportWidget } from 'hooks'
import { ROUTES } from 'helpers/constants'
import { BODY_PADDING_DESKTOP, BODY_PADDING_MOBILE } from 'constants/styles'

import CopyRight from './CopyRight'
import FooterNav from './FooterNav'

import teleportLogo from 'assets/images/logo-small.png'

const {
  legal: { terms_conditions, privacy_policy, dater_terms },
  domain_links: { careers },
  social: { twitter, instagram },
} = config
const { LANDING } = ROUTES

const Footer = () => {
  const { lg } = useBreakpoints()
  const customerSupport = useCustomerSupportWidget()

  const FOOTER_LINKS = useMemo(
    () => [
      {
        title: 'Community',
        links: [
          {
            label: 'Instagram',
            to: instagram.page_url,
          },
          {
            label: 'Twitter',
            to: twitter.page_url,
          },
        ],
      },
      {
        title: 'Company',
        links: [
          {
            label: 'Careers',
            to: careers,
          },
          {
            label: 'Live Support',
            to: '#',
            onClick(e) {
              e.preventDefault()
              customerSupport.show()
            },
            hidden: true,
          },
        ],
      },
      {
        title: 'Legal',
        links: [
          {
            label: 'Terms & Conditions',
            to: terms_conditions,
          },
          {
            label: 'Terms of Use',
            to: dater_terms,
          },
          {
            label: 'Privacy Policy',
            to: privacy_policy,
          },
        ],
      },
    ],
    [customerSupport]
  )

  return (
    <footer
      className={classnames(
        'flex justify-between py-12 bg-background flex-wrap lg:flex-nowrap',
        BODY_PADDING_DESKTOP,
        BODY_PADDING_MOBILE
      )}
    >
      <div className="flex flex-none flex-col justify-between pr-6 mb-8 w-full lg:w-52 lg:mb:0">
        <Link to={LANDING}>
          <img src={teleportLogo} className="h-20 text-white" alt="logo" />
        </Link>
        {lg && <CopyRight />}
      </div>
      <div className="flex justify-between max-w-screen-md w-full mb-14 flex-wrap md:w-4/6 md:flex-nowrap lg:justify-around lg:flex-1 lg:mb-0">
        {FOOTER_LINKS.map(({ links, title }, index) => (
          <FooterNav key={`FOOTER-${index}`} links={links} title={title} />
        ))}
      </div>
      <div className="flex w-full md:w-52">{!lg && <CopyRight />}</div>
    </footer>
  )
}

export default Footer
